import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import { Row } from 'react-bootstrap'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { FORM_PESO_BRUTO } from '../../../../config/forms'
import { renderTextField } from '../../../Forms/fieldRenderers'
import PesadoBalanzaModoManual from '../../components/bruto/PesadoBalanzaModoManual'
import CamposPesado0 from '../../components/pesado/CamposPesado0'
import ConfirmarCalle from '../../components/bruto/ConfirmarCalle'
import CeaInfo from '../../components/CeaInfo'
import InfoIcon from '@material-ui/icons/Info'
import VolverALeer from '../../components/pesado/VolverALeer'

function PesadoBrutoBalanceroManual (props) {
  const { cpe, cea, submitPesoBruto, pesadoAuto, pesoBruto } = props
  const [timeLeft, setTimeLeft] = useState(0)
  const [pesadoOk, setPesadoOk] = useState(false)
  const [init, setInit] = useState(true)

  const cereal = cea.cereal
  const claveCereal = cea.claveCereal
  const cerealVariedad = cea.cerealVariedad
  const calificacion = cea.calificacionCereal
  const camion = cea.camion
  const chofer = cea.chofer
  const exportador = cea.exportador
  const pesoBrutoOrigen = cea.pesoBrutoOrigen
  const pesoTaraOrigen = cea.pesoTaraOrigen
  const pesoNetoOrigen = cea.pesoNetoOrigen

  const datosCea = {
    cereal,
    claveCereal,
    cerealVariedad,
    calificacion,
    camion,
    chofer,
    exportador,
    pesoBrutoOrigen,
    pesoTaraOrigen,
    pesoNetoOrigen
  }

  useEffect(() => {
    if (cpe && cpe.numero && cpe.pesoBruto && cpe.calleDeVolcadora && timeLeft === 0 && init) {
      setPesadoOk(true)
      setTimeLeft(10)
      setInit(false)
    }

    const interval = setInterval(async () => {
      const { change: formChange } = props
      if (!cpe && pesadoOk) {
        setPesadoOk(false)
      }

      if (cpe && cpe.pesoBruto) {
        if (!pesoBruto) {
          formChange('pesoBruto', cpe.pesoBruto)
          formChange('numero', cpe.numero)
        }

        if (pesadoOk) {
          if (timeLeft > 0) {
            setTimeLeft(timeLeft - 1)
            // console.log(timeLeft)
          } else {
            props.deleteCpe(cpe.numero)
            setPesadoOk(false)
            clearInterval(interval)
          }
        }
      }
    }, [1000])

    return () => {
      clearInterval(interval)
    }
  }, [props, cpe, timeLeft, pesoBruto, pesadoOk, init])

  const handleSubmit = () => {
    setPesadoOk(true)
    setTimeLeft(15)
    submitPesoBruto()
  }

  return (
    <>
      {((!cpe && !datosCea.cereal) || (cpe && !cpe.pesoBruto))
        ? <PesadoBalanzaModoManual
          altaPesado={props.altaPesado}
          onBlurInput={props.onBlurInput}
          actualizarCalleVolcadora={props.actualizarCalleVolcadora}
          deleteCpe={props.deleteCpe}
        />
        : (cpe && pesoBruto && datosCea.cereal)
          ? <Row className='container-pesado-bruto'>
            <div className='container-info-bruto'>
              <div className='bruto-peso-numero'>
                <div className='container-peso-bruto'>
                  <Field
                    className='peso-cabezal peso-cabezal-bruto'
                    name='pesoBruto'
                    component={renderTextField}
                    disabled={pesadoAuto}
                    label='Peso bruto'
                    maxLength={5}
                  />
                </div>
                <div className='campos-cea-destare campos-cea-bruto'>
                  <CamposPesado0
                    label='Número de CTG'
                  />
                </div>

              </div>

              { datosCea.cereal && cea.cereal && <CeaInfo cea={datosCea} /> }
              { cea.cereal && !cea.caravana && <div className='msj-info-alerta'>
                <InfoIcon style={{ color: '#ffffff', margin: '0 8px 0 0' }} />
                                                 Atención: descarga silo aparte
              </div>
              }

            </div>
            <div className='container-msj-info-bruto'>
              <ConfirmarCalle
                cpe={cpe}
                datosCea={datosCea}
                pedirConfirmacion={props.pedirConfirmacion}
                handleSubmit={handleSubmit}
                actualizarCalleVolcadora={props.actualizarCalleVolcadora}
                rechazarPesoBruto={props.rechazarPesoBruto}
                clearFormRechazo={props.clearFormRechazo}
                dialogOpen={props.dialogOpen}
              />

              { cpe && cpe.numero && !pesadoOk
                ? <VolverALeer
                  deleteCpe={props.deleteCpe}
                  cpe={cpe}
                />
                : <></>
              }
            </div>
          </Row>
          : (!pesadoOk) && <div className='loader' />
      }
    </>
  )
}

const selector = formValueSelector(FORM_PESO_BRUTO)

const mapStateToProps = (state) => ({
  pesoBruto: selector(state, 'pesoBruto')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_BRUTO
})

export default withRedux(withReduxForm(PesadoBrutoBalanceroManual))
